import React from "react";

import { epocToDate } from "utils";
import { formatBytes, formatTimeDuration } from "utils";
import { CONTENT, CLIENT_ERROR_MSGS, BackupWithWarnErrCodes } from "consts";
import { ReactComponent as LogsSafe } from "assets/images/app_svg/logs_safe.svg";
import { ReactComponent as LogsFail } from "assets/images/app_svg/logs_fail.svg";
import { ReactComponent as LogsStopped } from "assets/images/app_svg/logs_stopped.svg";

function BackupLogs(props) {
  function Title() {
    function header() {
      switch (props.data.status) {
        case props.enums.BackupScheduleStatus.SUCCESS:
          return CONTENT.appLogs.backup.success;
        case props.enums.BackupScheduleStatus.CANCELLED:
          return CONTENT.appLogs.backup.stopped;
        case props.enums.BackupScheduleStatus.FAILURE:
          return CONTENT.appLogs.backup.failed;
        case props.enums.BackupScheduleStatus.PAUSED:
          return CONTENT.appLogs.backup.paused;
        default:
          return "Invalid log";
      }
    }

    return (
      <div className="logs_item_title">
        {props.data.status === props.enums.BackupScheduleStatus.SUCCESS ? (
          BackupWithWarnErrCodes.includes(props.data.errorCode) ? (
            <LogsStopped />
          ) : (
            <LogsSafe />
          )
        ) : props.data.status === props.enums.BackupScheduleStatus.FAILURE ? (
          <LogsFail />
        ) : (
          <LogsStopped />
        )}
        <p>
          {header()}

          <span>
            {" "}
            ({formatBytes(props.data.size >= 0 ? props.data.size : 0)})
          </span>
        </p>
      </div>
    );
  }

  function Detials() {
    return (
      <div className="logs_item_details">
        <span>{epocToDate(props.timeStamp, "MMM d yyyy, hh:mm:ss")}</span>
        <span> | </span>
        <span>Duration: {formatTimeDuration(props.data.duration)}</span>
        <span> | </span>
        <span>
          {props.data.mode === 1 ? "Incremental Backup" : "Full Backup"}
        </span>
      </div>
    );
  }

  function FailureReason() {
    const errorCode = props.enums.ErrorCodes.props[props.data.errorCode]
      ? props.enums.ErrorCodes.props[props.data.errorCode].key
      : null;
    return (
      <div class="logs_item_msg_list error_msg">
        <p>
          {errorCode && CLIENT_ERROR_MSGS[errorCode]
            ? CLIENT_ERROR_MSGS[errorCode]
            : CLIENT_ERROR_MSGS.default}
        </p>
      </div>
    );
  }

  return (
    <div
      className={[
        "logs_item logs_",
        props.data.status === props.enums.BackupScheduleStatus.SUCCESS
          ? BackupWithWarnErrCodes.includes(props.data.errorCode)
            ? "stopped"
            : "safe"
          : props.data.status === props.enums.BackupScheduleStatus.FAILURE
          ? "failed"
          : "stopped"
      ].join("")}
    >
      <Title />

      <Detials />
      {(props.data.status === props.enums.BackupScheduleStatus.FAILURE ||
        (props.data.status === props.enums.BackupScheduleStatus.SUCCESS &&
          BackupWithWarnErrCodes.includes(props.data.errorCode))) && (
        <FailureReason />
      )}
    </div>
  );
}

export default BackupLogs;
